import { createSelector } from '@reduxjs/toolkit';

import { TApplicationState } from 'shared/types/redux';
import { hasValidPhone } from '../../utils/agent';

export const buildersSelector = (state: TApplicationState) => {
  return state.newbuilding.builders;
};

export function buildersWithPhonesSelector(state: TApplicationState) {
  const {
    newbuilding: { builders },
  } = state;

  if (builders) {
    return builders.filter(builder => builder.showPhone && builder.phone);
  }

  return [];
}

export const buildersWithValidPhonesSelector = createSelector([buildersSelector], builders =>
  builders.filter(hasValidPhone),
);
